import { Injectable } from '@angular/core';
import { UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DevModeAccessGuard  {
  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let hostLocationLocalHoost: boolean = location.hostname === 'localhost';
    if(!hostLocationLocalHoost){
      window.open(window.location.origin, '_self');
    }
    return hostLocationLocalHoost;
  }

}
